export default __webpack_public_path__ + "static/media/melted_snowman.65457e10.png";